export const FETCH_LOCALITIES_REQUEST = 'FETCH_LOCALITIES_REQUEST';
export const FETCH_LOCALITIES_SUCCESS = 'FETCH_LOCALITIES_SUCCESS';
export const FETCH_LOCALITIES_FAILURE = 'FETCH_LOCALITIES_FAILURE';

export const fetchLocalitiesRequest = (pincode) => {
    return {
        type: FETCH_LOCALITIES_REQUEST,
        payload: pincode
    };
};

export const fetchLocalitiesSuccess = ({ localities = [], district = '', state = '' } = {}) => {
    return {
        type: FETCH_LOCALITIES_SUCCESS,
        payload: { localities, district, state }
    };
};

export const fetchLocalitiesFailure = (error) => {
    return {
        type: FETCH_LOCALITIES_FAILURE,
        payload: error
    };
};
